<template>
  <div class="modal fade" :id="'kt_modal_' + id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitSendMail" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('qvct_survey.send.link')}}</h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <TagifyInput
                  :parent-id="'#'+id"
                  containerClass="-flex flex-column mb-5 fv-row"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  size="lg"
                  :is-required="true"
                  :label="$t('qvct_survey.send.email')"
                  labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                  v-model="formData.to"
                  :name="`kt_tagify_to_`+id"
                  :helperText="$t('attributes.tag_input_text')"
              />


            </div>


          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
            <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, defineEmits, defineProps, computed, onMounted, watch} from "vue";
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"
import TagifyInput from "@/components/TagifyInput.vue";
import {useRoute} from "vue-router";

const store = useStore()
const {locale} = useLocales()
const route = useRoute()
const emit = defineEmits(['reloadDatatable'])
const props = defineProps({
  id: { type: String, required: true },
})


const processing = ref(false)
const formData = ref({
  to: []
})


function closeModal(){
  $("#kt_modal_" + props.id).modal('hide')
}

function submitSendMail() {
  processing.value = true
  return store.dispatch('qvctSurvey/sendLinkMail', {
    emails: formData.value.to,
    surveyId: route.params.id
  })
      .then(res => {
        $('#kt_modal_'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("qvct.survey_link_sent_successfully"))
        emit('sent')
      })
      .finally(() => processing.value = false)

}


</script>

<style scoped></style>
